'use strict';

import BGMController1 from './BGMController1';
import BGMController2 from './BGMController2';
import BGMController3 from './BGMController3';
import BGMController4 from './BGMController4';
import BGMController5 from './BGMController5';

import SEController from './SEController';
import { Howler } from 'howler';
import UPParser from 'ua-parser-js';

class SoundController {
  constructor(bgm_pathes, se_path, force_mute = false) {
    let parser = new UPParser();
    let html5 = false;
    if (parser.getOS().name === 'iOS') {
      // BGM sometimes breaks in iOS. So, use html5 instead of web audio.
      html5 = true;
    }

    let shouldMute = force_mute;
    if (!shouldMute) {
      this.bgms = [
        new BGMController1(bgm_pathes[0], html5),
        new BGMController2(bgm_pathes[1], html5),
        new BGMController3(bgm_pathes[2], html5),
        new BGMController4(bgm_pathes[3], html5),
        new BGMController5(bgm_pathes[4], html5),
      ];
      this.se = new SEController(se_path);
    }
    this._playing = [];
    /* hold ids because sometimes Howler seems to miss them */
    this.force_mute = shouldMute;
    this._muting = false;
    this.initCallbacks = [
      () => {
        this._incInitComplete = true;
      },
    ];
    /* holds a function before init of inc is complete */
    this._incInitComplete = false;
  }

  mute(bool) {
    if (this.force_mute) {
      return;
    }

    this._muting = bool;
    Howler.mute(bool);
  }

  bgmPlay(sprite_key, loop = false) {
    if (this.force_mute) {
      return;
    }

    if (this._muting) {
      return;
    }

    if (this.isBGMPlaying() && this._latestBGM === sprite_key) {
      return;
    }

    this.bgmStop();

    this.bgms.forEach(bgm => {
      if (bgm.hasKey(sprite_key)) {
        let id = bgm.loop(loop).play(sprite_key);
        bgm.on(
          'play',
          () => {
            this._pushCache(id);
            this._latestBGM = sprite_key;
          },
          id
        );
        bgm.on(
          'end',
          () => {
            this._popCache(id);
          },
          id
        );
      }
    });
  }

  isBGMPlaying() {
    if (this.force_mute) {
      return false;
    }

    return this._playing.length > 0;
  }

  bgmStop() {
    if (this.force_mute) {
      return;
    }
    this._playing.forEach(l => {
      this.bgms.forEach(bgm => {
        bgm.on(
          'stop',
          () => {
            this._popCache(l);
          },
          l
        );

        bgm.stop(l);
      });
    });
  }

  sePlay(sprite_key) {
    if (this.force_mute) {
      return;
    }

    if (this._muting) {
      return;
    }

    this.se.play(sprite_key);
  }

  _pushCache(id) {
    if (this._playing.indexOf(id) === -1) {
      this._playing.push(id);
    }
  }

  _popCache(id) {
    if (this._playing.indexOf(id) !== -1) {
      this._playing.splice(this._playing.indexOf(id), 1);
    }
  }

  _clearCache() {
    this._playing = [];
  }
}

export default SoundController;
